'use client';

import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from '../state/store';
import { LocaleProvider } from '../contexts/LocaleProvider';
import { DeviceProvider } from '../contexts/DeviceContext';
import { DimProvider } from '../contexts/DimContext';
import { LoadingProvider } from '../contexts/LoadingContext';
import { ResponsiveProvider } from '../contexts/ResponsiveContext';
import { DefinitionsProvider } from '../contexts/DefinitionsContext';
import { ApplicationsDocumentsProvider } from '../graphql/pimcore/modules/documents/contexts/ApplicationsDocumentsProvider';
import pimcoreClient from '../graphql/pimcore/apollo/pimcoreClient';
import { ResourceLibraryProviders } from '../graphql/pimcore/modules/resourceLibrary/contexts/ResourceLibraryProviders';
import { SiteNavigationProviders } from '../graphql/pimcore/modules/siteNavigation/contexts/SiteNavigationProviders';
import { SiteContentProviders } from '../graphql/pimcore/modules/siteContent/contexts/SiteContentProviders';
import { poppins, themeOptions } from '@/themes/themeOptions';

const mainTheme = createTheme({
    ...themeOptions,
    typography: {
        ...themeOptions.typography,
        // 直接用 next/font 提供的字族字串；不使用 CSS 變數
        fontFamily: `${poppins.style.fontFamily}, sans-serif`,
    },
});

export default function Providers({ children }: { children: React.ReactNode }) {
    return (
        <ThemeProvider theme={mainTheme}>
            <LocaleProvider>
                <ReduxProvider store={store}>
                    <ResponsiveProvider>
                        <DefinitionsProvider>
                            <DeviceProvider>
                                <DimProvider>
                                    <LoadingProvider>
                                        <SiteContentProviders>
                                            <ApplicationsDocumentsProvider
                                                apolloClient={pimcoreClient}
                                            >
                                                <SiteNavigationProviders>
                                                    <ResourceLibraryProviders>
                                                        {children}
                                                    </ResourceLibraryProviders>
                                                </SiteNavigationProviders>
                                            </ApplicationsDocumentsProvider>
                                        </SiteContentProviders>
                                    </LoadingProvider>
                                </DimProvider>
                            </DeviceProvider>
                        </DefinitionsProvider>
                    </ResponsiveProvider>
                </ReduxProvider>
            </LocaleProvider>
        </ThemeProvider>
    );
}
